import { Route, Routes } from "react-router-dom";
import GTMProjectsRoutes from "./gtm";
import ProjectRoutes from "./projects";
import SalesDashboard from "./salesDashboard";

const DevelopmentRoutes = () => {
  return (
    <Routes>
      <Route path="projects/*" element={<ProjectRoutes />} />
      <Route path="gtm-projects/*" element={<GTMProjectsRoutes />} />
      <Route path="sales-dashboard/*" element={<SalesDashboard />} />
    </Routes>
  );
};

export default DevelopmentRoutes;
